/** Canonical `?tab=` values for settings drawer / mobile settings routes. */
export const SETTINGS_TABS = [
  'setup-progress',
  'setting-business-details',
  'setting-user-role',
  'setting-outlet',
  'setting-profile',
  'custom-fields',
  'webhook',
] as const;

/** Legacy and shorthand values mapped to canonical tab ids. */
export const SETTINGS_TAB_ALIASES: Record<string, string> = {
  setup: 'setup-progress',
  'setup-status': 'setup-progress',
  general: 'setting-business-details',
  'business-details': 'setting-business-details',
  users: 'setting-user-role',
  'team-roles': 'setting-user-role',
  outlets: 'setting-outlet',
  outlet: 'setting-outlet',
  projects: 'setting-outlet',
  profile: 'setting-profile',
  'custome-field': 'custom-fields',
  'custom-field': 'custom-fields',
};

export type SettingsTab = (typeof SETTINGS_TABS)[number];
export const DEFAULT_SETTINGS_TAB: SettingsTab = 'setting-business-details';
